var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system-box"},[_c('el-form',{attrs:{"label-width":"120px"}},[_c('FormEdit',{ref:"FormEdit",attrs:{"action":_vm.$api.url_upload_pu,"formItems":_vm.formItems,"areaIdsChecked":_vm.areaIdsChecked}}),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitHandler}},[_vm._v("提交")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }